import { Feature } from '../apollo/graphqlSchema';
import { useBootstrapSelector } from '../../redux/selectorHooks';

export const useCheckFeatureFunction = () => {
  const enabledFeatures = useBootstrapSelector('enabledFeatures');
  return (feature: Feature) => enabledFeatures?.includes(feature) ?? false;
};

const useCheckFeature = (feature: Feature): boolean => {
  const checkFunc = useCheckFeatureFunction();
  return checkFunc(feature);
};

export const useShowSql = () => useCheckFeature(Feature.ShowSql);

export const useShowBraze = () => useCheckFeature(Feature.Braze);

export const useDataModelerFeature = () => useCheckFeature(Feature.DataModeler);

export const useDataModelerEditFeature = () =>
  useCheckFeature(Feature.DataModelerEdit);

export const useDataModelerEditSeFeature = () =>
  useCheckFeature(Feature.DataModelerEditSe);

export const useShowWorkspace = () => useCheckFeature(Feature.Workspace);

export const useShowGeo = () => useCheckFeature(Feature.Geo);

export const useAiAdminFeature = () => useCheckFeature(Feature.AiAdmin);

export const useAiExplainFeature = () => useCheckFeature(Feature.AiExplain);

export const useAiCreateReportFeature = () =>
  useCheckFeature(Feature.AiCreateReport);

export const useShowAiDebug = () => useCheckFeature(Feature.AiDebug);

export const useExternalEmbedFeature = () =>
  useCheckFeature(Feature.ExternalEmbed);

export const useCseAdminFeature = () => useCheckFeature(Feature.CseAdmin);
